import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";
import { TaskRequest, TaskRequestStatusTypeCode } from "./task-request";
import { SelectionItem } from "./definitions";

export class AtsTaskRequestSearchResult extends SearchResult<AtsTaskRequestInfo> {}

export class AtsTaskRequestInfo {
    @fromClass Task: TaskRequest;
    OrganizationId: string;
    OrganizationName: string;
    TaskRequestId: string;
    TaskRequestName: string;
}

export type Filter = {
    organization?: string;
    status?: number;
    type?: string;
    exportTaskId?: string;
    range?: string | [];
    missing?: string;
};

export type HeadersType = {
    label: string;
    sort?: string;
    key?: string;
    class?: string;
};

export type SortParamsType = {
    column: string;
    order: "asc" | "desc";
};

export type Flag = {
    open: boolean;
};

export type TabsType = {
    label: string;
    value: number;
};

export enum TaskRequestType {
    SyncS3 = "SyncS3",
    Sync = "Sync",
    DeleteApplications = "DeleteApplications",
    AimEnrollment = "AimEnrollment",
    FieldIndex = "FieldIndex",
    PutPhase = "PutPhase",
    PatchApplicationValues = "PatchApplicationValues",
    Reindex = "Reindex",
    ReindexApplications = "ReindexApplications",
    CollaborationAssignment = "CollaborationAssignment",
    DecisionLetter = "DecisionLetter",
    DirectPhaseEvaluationAssignment = "DirectPhaseEvaluationAssignment",
    RunAssignmentRules = "RunAssignmentRules",
    Reindexing = "Reindexing",
    DeleteDataDictionaryVectorStore = "DeleteDataDictionaryVectorStore",
    DeleteProgramVectorStore = "DeleteProgramVectorStore",
    PopulateDataDictionaryVectorStore = "PopulateDataDictionaryVectorStore",
    PopulateProgramVectorStore = "PopulateProgramVectorStore",
    SendInquiryToContacts = "SendInquiryToContacts",
    CeebImport = "CeebImport",
    HideProgram = "HideProgram",
    UpdatePrograms = "UpdatePrograms",
    Export = "Export",
    accountactivationemail = "accountactivationemail",
    SendEmails = "SendEmails",
    EnsureUserInvitations = "EnsureUserInvitations",
    SendUserInvitations = "SendUserInvitations"
}

export const TASK_REQUEST_TYPE_FILTER: SelectionItem[] = [
    { label: "Any type", value: null },
    { label: "SyncS3", value: TaskRequestType.SyncS3, hexColor: "#FFADAD" },
    { label: "Sync", value: TaskRequestType.Sync, hexColor: "#FFD6A5" },
    { label: "Delete Applications", value: TaskRequestType.DeleteApplications, hexColor: "#FDFFB6" },
    { label: "Aim Enrollment", value: TaskRequestType.AimEnrollment, hexColor: "#CAFFBF" },
    { label: "Field Index", value: TaskRequestType.FieldIndex, hexColor: "#9BF6FF" },
    { label: "Put Phase", value: TaskRequestType.PutPhase, hexColor: "#A0C4FF" },
    { label: "Patch Application Values", value: TaskRequestType.PatchApplicationValues, hexColor: "#BDB2FF" },
    { label: "Reindex", value: TaskRequestType.Reindex, hexColor: "#FFC6FF" },
    { label: "Reindex Applications", value: TaskRequestType.ReindexApplications, hexColor: "#E6E6FA" },
    { label: "Collaboration Assignment", value: TaskRequestType.CollaborationAssignment, hexColor: "#F0E68C" },
    { label: "Decision Letter", value: TaskRequestType.DecisionLetter, hexColor: "#AFEEEE" },
    { label: "Direct Phase Evaluation Assignment", value: TaskRequestType.DirectPhaseEvaluationAssignment, hexColor: "#F5DEB3" },
    { label: "Run Assignment Rules", value: TaskRequestType.RunAssignmentRules, hexColor: "#D2B48C" },
    { label: "Reindexing", value: TaskRequestType.Reindexing, hexColor: "#BC8F8F" },
    { label: "Delete Data Dictionary Vector Store", value: TaskRequestType.DeleteDataDictionaryVectorStore, hexColor: "#F4A460" },
    { label: "Delete Program Vector Store", value: TaskRequestType.DeleteProgramVectorStore, hexColor: "#98FB98" },
    { label: "Populate Data Dictionary Vector Store", value: TaskRequestType.PopulateDataDictionaryVectorStore, hexColor: "#ADD8E6" },
    { label: "Populate Program Vector Store", value: TaskRequestType.PopulateProgramVectorStore, hexColor: "#DA70D6" },
    { label: "Send Inquiry To Contacts", value: TaskRequestType.SendInquiryToContacts, hexColor: "#EEE8AA" },
    { label: "Ceeb Import", value: TaskRequestType.CeebImport, hexColor: "#FFA07A" },
    { label: "Hide Program", value: TaskRequestType.HideProgram, hexColor: "#B0E0E6" },
    { label: "Update Programs", value: TaskRequestType.UpdatePrograms, hexColor: "#DDA0DD" },
    { label: "Export", value: TaskRequestType.Export, hexColor: "#8FBC8F" },
    { label: "Account Activation Email", value: TaskRequestType.accountactivationemail, hexColor: "#F08080" },
    { label: "Send Emails", value: TaskRequestType.SendEmails, hexColor: "#9ACD32" },
    { label: "Ensure User Invitations", value: TaskRequestType.EnsureUserInvitations, hexColor: "#4682B4" },
    { label: "Send User Invitations", value: TaskRequestType.SendUserInvitations, hexColor: "#D8BFD8" }
];

export const TASK_REQUEST_STATUSES: SelectionItem[] = [
    { label: "All Statuses", value: null },
    { label: "Requested", value: TaskRequestStatusTypeCode.Requested, color: "pending-color", hexColor: "#fde68a" },
    { label: "Running", value: TaskRequestStatusTypeCode.Running, color: "pending-color", hexColor: "#fde68a" },
    { label: "Complete", value: TaskRequestStatusTypeCode.Complete, color: "complete-color", hexColor: "#a7f3d0" },
    { label: "Error", value: TaskRequestStatusTypeCode.Error, color: "error-color", hexColor: "#fecaca", styleColor: "#7f1d1d" }
];

export function getStatusName(index): string {
    return TASK_REQUEST_STATUSES.find((item) => item.value === index)?.label;
}

export function getStatusColor(index): string {
    return TASK_REQUEST_STATUSES.find((item) => item.value === index)?.color ?? "pending-color";
}
